<template lang="html">

  <section class="tools">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Tools</h4>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
              </span>
            </div>
            <b-table 
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="username"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
            <template v-slot:cell(runButton)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                    <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="curItem=data.item; run()" aria-expanded="true" aria-controls="collapseOne">
                      <b-button variant="primary mr-1" v-if="curModel!='DEFAULT' || data.item.value == 'updateGrid' || data.item.value == 'clearGridCache' || data.item.value == 'clearAllCache'"> RUN <i class="mdi mdi-check-outline"></i></b-button>
                      <b-button variant="primary mr-1" v-else disabled> RUN <i class="mdi mdi-check-outline"></i></b-button>
                    </a>
                  </h4>
                </b-row>
            </template>
            </b-table>            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'tools',
  methods: {    
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ]),
    refreshTable(){},
    run(){
      if (this.curItem.value == "updateGrid") {
        this.setSpinnerStatus(true);
        this.axios
          .get('/ccb/auth/fe/tools/updateGrid', { params: {},
            ...this.authHeader})
          .then(response => {
            this.$bvModal.msgBoxOk("Refresh model grids in esecuzione. Il risultato arriverà per email all'indirizzo: " + response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          })
          .finally(e=>{
              this.setSpinnerStatus(false);
          })
      }else if(this.curItem.value == "clearGridCache"){
        this.setSpinnerStatus(true);
         this.axios
          .get('/ccb/auth/fe/tools/clearGridCache', { params: {},
              ...this.authHeader})
            .then(response => {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
            })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
        })
        .finally(e=>{
            this.setSpinnerStatus(false);
        })       
      }else if(this.curItem.value == "clearAllCache"){
        this.setSpinnerStatus(true);
         this.axios
          .get('/ccb/auth/fe/tools/clearAllCache', { params: {},
              ...this.authHeader})
            .then(response => {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
            })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
        })  
      }else if(this.curItem.value == "checkGridAll"){
        window.open('/ccb/public/api/checkGrid/ALL/'+this.curModel , '_blank');
      }else if(this.curItem.value == "checkGridMain"){
        window.open('/ccb/public/api/checkGrid/MAIN/'+this.curModel , '_blank');
      }
    }
  },
  watch: {    
  },
  data () {
    return {
      currentPage:1,
      perPage:10,
      totalRows:0,
      sortBy:'text',
      sortDesc: false,
      curItem:null,
      items: [        
        {text: "Empty ALL cache", value: "clearAllCache"},
        //{text: "Empty Grid/rules cache", value: "clearGridCache"},
        {text: "Refresh model grids", value: "updateGrid"},
        {text: "Check Model (all countries)", value: "checkGridAll"},
        {text: "Check Model (main countries only)", value: "checkGridMain"}
      ],
      fields: [
        {
          key: 'text',
          label: '',
          sortable: false
        },
        {
          key: 'runButton',
          label: '',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapState([
      'curLanguage',
      'curModel',
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader'
    ])
  },
  mounted() {
    this.setCurApp('ccadm');
    this.refreshTable();
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/_variables.scss';
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: .25rem;
}
</style>
